module.exports = {"slides":[{"icon":"f1-slid-1","color":"turquoise","txt":"f1_slid_1"},{"icon":"f1-slid-2","color":"turquoise","txt":"f1_slid_2"},{"icon":"f1-slid-3","color":"turquoise","txt":"f1_slid_3"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/fact1_b_s.json
// module id = yYdt
// module chunks = 1